// extracted by mini-css-extract-plugin
export default {"content":"Home_content__H2PXq","back":"Home_back__2E-fg"};